export const AUTH_STORAGE_CHANGED_EVENT = 'auth-storage-changed';

const dispatchStorageChange = (key: string) => {
  window.dispatchEvent(
    new CustomEvent(AUTH_STORAGE_CHANGED_EVENT, {
      detail: { key },
    }),
  );
};

export const storeData = async (key: string, value: string) => {
  try {
    localStorage.setItem(key, value);
    dispatchStorageChange(key);
    return 1;
  } catch (error) {
    console.error(`Error saving ${key} to localStorage:`, error);
    return 0;
  }
};

export const storeDataJson = async (key: string, value: unknown) => {
  try {
    const jsonValue = JSON.stringify(value);
    localStorage.setItem(key, jsonValue);
    dispatchStorageChange(key);
    return 1;
  } catch (error) {
    console.error(`Error saving ${key} JSON to localStorage:`, error);
    return 0;
  }
};

export const getData = async (key: string) => {
  try {
    const value = localStorage.getItem(key);
    return value !== null ? value : 0;
  } catch (error) {
    console.error(`Error reading ${key} from localStorage:`, error);
    return 0;
  }
};

export const deleteData = async (key: string) => {
  try {
    localStorage.removeItem(key);
    dispatchStorageChange(key);
  } catch (error) {
    console.error('Error removing item from localStorage:', error);
  }
};
